import { Button, FormInput } from "@farzoom/common-ui-components";
import { Col, Row, Typography } from "antd";
import { useContext } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { createUseStyles } from "react-jss";
import { PRODUCT_MODEL } from "../../utils/purchaseLotModels";
import { LotsSubComponent } from "./lots";
import { useStyles } from "@app/guranteeFormWrapper/styles";
import { BgFormType } from "@services/guarantees/types";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { VerticalSpace } from "@app/UI/VerticalSpace";

const { Text } = Typography;

const productsStyles = createUseStyles({
  row: {
    "& .ant-space-item:first-of-type $delete button": {
      marginTop: 18,
    },
  },
  delete: {
    alignSelf: "center",
  },
});

export const ProductsList = ({ lotIndex }: LotsSubComponent) => {
  const classes = useStyles();
  const productsClasses = productsStyles();
  const { control, setValue } = useFormContext<BgFormType>();
  const { formDisabled, prefix } = useBgFormContext();

  const currentPrefix = prefix ? `${prefix}.purchase.lots` : "purchase.lots";

  const {
    fields: products,
    prepend,
    remove,
  } = useFieldArray({
    control,
    name: `${currentPrefix}.${lotIndex}.products` as `purchase.lots.${number}.products`,
  });

  const onAddProduct = () => {
    prepend(PRODUCT_MODEL);
  };
  const onRemove = (idx) => {
    remove(idx);
  };

  return (
    <VerticalSpace>
      <Text strong>
        <div className={classes.actionTitle}>
          <span>Товары</span>
          {!formDisabled && (
            <Button type="outlined" iconName="add" title="Добавить товар" onClick={onAddProduct} />
          )}
        </div>
      </Text>
      <VerticalSpace size="small" className={productsClasses.row}>
        {products.map((product, idx) => (
          <Row key={product.id} gutter={16} align="top">
            <Col span={8}>
              <FormInput
                name={`${currentPrefix}.${lotIndex}.products.${idx}.okpdCode`}
                control={control}
                setValue={setValue}
                label={idx > 0 ? "" : "Код по ОКПД"}
              />
            </Col>
            <Col flex="auto">
              <FormInput
                name={`${currentPrefix}.${lotIndex}.products.${idx}.okpdName`}
                control={control}
                setValue={setValue}
                label={idx > 0 ? "" : "Название по ОКПД"}
              />
            </Col>
            {products.length > 1 && !formDisabled && (
              <Col flex="32px" className={productsClasses.delete}>
                <Button
                  type="outlined"
                  iconName="remove"
                  title="Удалить товар"
                  onClick={() => onRemove(idx)}
                />
              </Col>
            )}
          </Row>
        ))}
      </VerticalSpace>
    </VerticalSpace>
  );
};
